import { Route, Routes, Navigate, Outlet} from 'react-router-dom'

const ProtectedRoute = () =>{
    var permissions ='';
  const permissionsdata =  localStorage.getItem('permissions');
  if(permissionsdata !== null && permissionsdata !== undefined){
    const permissionsreadData = JSON.parse(permissionsdata);
    const filteredData = permissionsreadData.filter(obj => {
        return obj.PermissionCode === 'VALIDATE_JOB' || obj.PermissionCode === 'AUTHORIZE_JOB'|| obj.PermissionCode === 'CREATE_JOB';
    });
    if(filteredData.length > 0){
        permissions = filteredData[0].PermissionCode;
    }
  }
  return (
        permissions === 'CREATE_JOB' ? 
        <Outlet/> : <Navigate to="/" replace />
        
  )

}

export default ProtectedRoute;